import "./ConnectSiteEquipmentToHardware.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ConnectSiteEquipmentToHardwareComponentController from "./ConnectSiteEquipmentToHardwareComponentController";

export default class ConnectToSiteEquipmentHardwareComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = ConnectSiteEquipmentToHardwareComponentController;
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/" +
            "SelectedEquipment/ConnectSiteEquipmentToHardware/ConnectSiteEquipmentToHardware.html";
    }
}

module("mmManagePortal").component("mmConnectSiteEquipmentToHardware", new ConnectToSiteEquipmentHardwareComponent());
